import { SoftwareItemCollection } from './software-item-collection';
var SoftwarePlatform = (function () {
    function SoftwarePlatform(items, icon, language) {
        if (items === void 0) { items = []; }
        if (icon === void 0) { icon = ''; }
        if (language === void 0) { language = ''; }
        this.language = '';
        this.language = language;
        this.collections = [];
        this.title = (items[0] || ({ platform: '' })).platform || '';
        this.icon = '_' + icon.toLowerCase().replace(/\s/g, '-') + '-logo';
        if (this.icon.indexOf('_macos') === 0) {
            this.icon = this.icon.replace('_macos', '_apple');
        }
        this.initializeItems(items);
    }
    SoftwarePlatform.prototype.initializeItems = function (items) {
        var _this = this;
        if (items === void 0) { items = []; }
        this.collections = items
            .filter(function (softwareItem) { return (Boolean(softwareItem.fileVersion)); })
            .map(function (softwareItem) { return softwareItem.fileVersion; })
            .filter(function (fileVersion, index, context) {
            return context.indexOf(fileVersion) === index;
        })
            .map(function (fileVersion) {
            var fileVersionItems = items.filter(function (item) {
                return (item.fileVersion || '').indexOf(fileVersion) === 0;
            });
            return new SoftwareItemCollection(fileVersionItems, _this.language);
        })
            .sort(function (a, b) {
            if (!a.selectedItem.fileDate || !b.selectedItem.fileDate) {
                return 0;
            }
            var aDate = new Date(a.selectedItem.fileDate);
            var bDate = new Date(b.selectedItem.fileDate);
            if (aDate < bDate) {
                return 1;
            }
            if (aDate > bDate) {
                return -1;
            }
            return 0;
        });
    };
    return SoftwarePlatform;
}());
export { SoftwarePlatform };
